// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__X8rc0","footer":"ReportModalFilter_footer__VRYNG"};